import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconIndividual = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1797_1483)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M7.5 8C9.433 8 11 6.433 11 4.5C11 2.567 9.433 1 7.5 1C5.567 1 4 2.567 4 4.5C4 6.433 5.567 8 7.5 8Z",
			stroke: "currentColor",
			strokeOpacity: .8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M7.5 10C3.44933 10 1.5 12.1187 1.5 13.5V14C1.5 14.5523 1.94772 15 2.5 15H12.5C13.0523 15 13.5 14.5523 13.5 14V13.5C13.5 12.125 11.5507 10 7.5 10Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1797_1483",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "currentColor",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgIconIndividual;
